import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import CheckinComponent from 'components/checkin/checkin';
import { checkin, getAllCheckins, deleteCheckin } from '../../actions/checkin';

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        checkin,
        getAllCheckins,
        deleteCheckin
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    var existingCheckin = null;

    if (ownProps.params.id && state.checkins != null && state.checkins.length > 0) {
        existingCheckin = _.find(state.checkins, (checkin) => {
            return checkin != null && checkin.id === ownProps.params.id;
        });
    }

    return {
        currentUser: state.currentUser,
        existingCheckin: existingCheckin
    };
}

const Checkin = connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckinComponent);

export default Checkin;


// WEBPACK FOOTER //
// ./src/app/containers/checkin/checkin.jsx